import auth from './../auth'

export default {
  admin: 'ROLE_LEADS_ADMIN',
  user: 'ROLE_LEADS_MODERATOR',
  getCurrentUserType () {
    if (!auth.user.authenticated) {
      return ''
    }
    const roles = auth.computed.userData().roles
    if (roles.indexOf(this.admin) !== -1) return this.admin
    if (roles.indexOf(this.user) !== -1) return this.user

    return ''
  }
}
